import { Navigate, Route, Routes } from "react-router-dom";

import { AppShell } from "@/components/app-shell";
import { RequireAuth } from "@/components/require-auth";
import { RequireScope } from "@/components/require-scope";
import { HUB_SECTIONS } from "@/lib/nav";
import Login from "@/pages/login";
import Dashboard from "@/pages/dashboard";
import SelectScope from "@/pages/select-scope";
import ComingSoon from "@/pages/coming-soon";
import Reports from "@/pages/reports";
import Donor from "@/pages/donor";
import Donors from "@/pages/donors";
import Donations from "@/pages/donations";

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      {/* After sign-in: pick the legal entity + operation unit for this session. */}
      <Route
        path="/select-scope"
        element={
          <RequireAuth>
            <SelectScope />
          </RequireAuth>
        }
      />

      {/* Everything inside the shell requires a session AND a chosen LE + OU. */}
      <Route
        element={
          <RequireAuth>
            <RequireScope>
              <AppShell />
            </RequireScope>
          </RequireAuth>
        }
      >
        <Route path="/" element={<Dashboard />} />
        <Route path="/reports" element={<Reports />} />
        <Route path="/donations" element={<Donations />} />
        <Route path="/donors" element={<Donors />} />
        <Route path="/donors/:id" element={<Donor />} />
        {/* Hub sections not built yet — one shared placeholder. */}
        {HUB_SECTIONS.filter((s) => !s.ready).map((s) => (
          <Route key={s.href} path={`${s.href}/*`} element={<ComingSoon />} />
        ))}
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
